import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { IProposta } from '../models/proposta';
import { IPropostaDTO } from '../dto/proposta-dto';
import { PropostasApi } from '../api/propostas.api';

@Injectable()
export class PropostasService extends ServiceBase<IProposta, IPropostaDTO> {
  constructor(api: PropostasApi) {
    super(api);
  }
}
